import formatDistance from 'date-fns/formatDistance';

export default function getFormattedDurationFromNow(input: number | Date) {
  return formatDistance(input, new Date(), {
    addSuffix: true,
  });
}
